import { createAction } from "redux-act";

export const LoadingOpenModalAction = createAction("Loading - Open Modal");
export const LoadingCloseModalAction = createAction("Loading - Close Modal");
